import { colors } from "@webdesserts/ui";
import styled from "styled-components";

export const Note = styled.p`
  color: ${colors.mid};
`;
